var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationCorporateService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.033 7.928c2.093 1.27 4.836 3.004 5.357 8.97M8.45 17.415c-.16-2.443-.312-5.685 4.276-9.534",
    stroke: "#C9A87A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.994 27.799h4.325l6.942.005H25.223c.67 0 2.122.357 2.579.35a1.456 1.456 0 0 0 1.142-.54c.14-.179 1.199-.197.29-.607.052-.22.056-.45.01-.672a1.604 1.604 0 0 0-.573-.917c-.742-.652-2.284-1.822-2.683-2.73a6.856 6.856 0 0 1-.578-2.886v-.893c.005-.702.01-1.428-.034-2.14a6.635 6.635 0 0 0-1.555-3.93 6.525 6.525 0 0 0-3.6-2.168 13.883 13.883 0 0 0-.431-.092h-.024l-.048-.01-.103-.023-.023-.007-.103-.022-.167-.036-1.043.01-.17.034-.162.03-.052.01h-.015a8.23 8.23 0 0 1-.2.039 6.564 6.564 0 0 0-3.656 1.966 6.673 6.673 0 0 0-1.769 3.782c-.062.714-.085 1.43-.07 2.147 0 .408 0 .83-.016 1.245v.007a9.503 9.503 0 0 1-.142 1.585 6.694 6.694 0 0 1-2.109 3.68 1.548 1.548 0 0 0-.555 1.823c.124.321.353.592.65.766.296.175.642.243.98.194z",
    fill: "#F6F1EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.206 11.323s-1.896 1.158-2.246 5.074c-.35 3.916.593 5.279-1.548 9.036.065 0-2.625 3.207-2.625 3.207l-.799-1.535 1.918-2.055 1.406-2.61v-3.46l.446-5.253 3.769-2.938 2.428-.783",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.278 9.71-.117-.024.117.024zm0 0 .055.011-.055-.01zM15.28 27.913h-4.916a.756.756 0 0 0-.104.008 1.01 1.01 0 0 1-.64-.122.95.95 0 0 1-.413-.47.902.902 0 0 1-.023-.607.941.941 0 0 1 .376-.498.759.759 0 0 0 .071-.054 8.062 8.062 0 0 0 2.642-4.463l.004-.019c.111-.617.17-1.242.173-1.87.018-.466.018-.937.018-1.377v-.024c-.017-.755.008-1.512.075-2.265a6.493 6.493 0 0 1 1.802-3.716 6.785 6.785 0 0 1 3.74-1.947h.002l.192-.035a.742.742 0 0 0 .074-.011l.053-.01.178-.033.006-.001.127-.024 1.037-.01.11.023h.006l.073.015c.02.007.042.012.063.017l.118.024.01.002.055.011c.029.006.057.01.086.012.144.028.277.056.408.085l.012.003a6.712 6.712 0 0 1 3.68 2.144 6.421 6.421 0 0 1 1.584 3.872v.006c.048.752.043 1.524.037 2.3V19.86a8.084 8.084 0 0 0 .724 3.492l.683-.31-.683.31a8.243 8.243 0 0 0 2.197 2.892c.19.146.321.349.373.573a.918.918 0 0 1-.186.768.912.912 0 0 1-.314.236.95.95 0 0 1-.401.086h-.016c-.515.007-1.082.012-1.84.012H23.168l-7.888-.006z",
    stroke: "url(#yw6hkhpida)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M22.156 11.747s2.368.974 2.713 4.89c.346 3.915-.855 5.389 1.265 9.136-.063 0 2.57 2.367 2.57 2.367l.921-.704-1.65-1.843-1.396-2.61v-3.46l-.445-5.253-3.741-2.938-2.41-.783",
    fill: "#C9A87A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.708 31.7a3.087 3.087 0 0 0 3.087-3.088H16.62a3.087 3.087 0 0 0 3.088 3.087z",
    fill: "#C9A87A",
    fillOpacity: 0.16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.313 28.612a3.087 3.087 0 1 1-6.175 0",
    stroke: "#C9A87A",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.226 9.614v-2.6",
    stroke: "#C9A87A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yw6hkhpida",
    x1: 24.053,
    y1: 16.618,
    x2: 12.192,
    y2: 18.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9A87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343E47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationCorporateService);
export default __webpack_public_path__ + "static/media/notificationCorporateService.da5bb47c503bf9dd73f19204bd5ecd42.svg";
export { ForwardRef as ReactComponent };